import React from 'react';

export default function HuongDanSuDung() {
  return (
    <div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">
          HƯỚNG DẪN SỬ DỤNG 
        </h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          Để giữ trang phục luôn đẹp, bền màu, đúng form dáng – bạn hãy tham khảo hướng dẫn bên dưới!
        </p>
      </div>

      <div className="space-y-10">

        {/* 1. Cách giặt & bảo quản */}
        <section className="flex gap-5 items-start">
          <div className="text-pink-500 text-3xl font-bold shrink-0">1</div>
          <div>
            <h2 className="text-lg font-semibold mb-2">Giặt và bảo quản đúng cách</h2>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-1">
              <li>Lộn trái sản phẩm trước khi giặt để hạn chế phai màu và bảo vệ hình in/thêu.</li>
              <li>Giặt riêng đồ trắng và đồ màu, tránh ngâm lâu với xà phòng mạnh.</li>
              <li>Nên giặt bằng tay hoặc máy chế độ nhẹ. Hạn chế vắt mạnh, tránh dùng nước nóng trên 40°C.</li>
              <li>Không sử dụng thuốc tẩy hoặc chất tẩy rửa mạnh với sản phẩm màu.</li>
              <li>Phơi nơi thoáng mát, tránh ánh nắng trực tiếp để màu vải bền lâu hơn.</li>
            </ul>
          </div>
        </section>

        {/* 2. Hướng dẫn sử dụng sản phẩm */}
        <section className="flex gap-5 items-start">
          <div className="text-pink-500 text-3xl font-bold shrink-0">2</div>
          <div>
            <h2 className="text-lg font-semibold mb-2">Cách sử dụng sản phẩm</h2>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-1">
              <li>Lựa chọn size vừa vặn với cơ thể để sản phẩm lên dáng đẹp và thoải mái.</li>
              <li>Phối cùng phụ kiện, giày dép phù hợp để tăng cá tính và phong cách.</li>
              <li>Tránh tiếp xúc với các vật sắc nhọn, hóa chất (nước hoa, xịt khử mùi) trực tiếp lên bề mặt vải.</li>
              <li>Nên dùng móc phù hợp khi treo áo, tránh làm dãn form hoặc hỏng vai áo.</li>
            </ul>
          </div>
        </section>

        {/* 3. Lưu ý đặc biệt theo chất liệu */}
        <section className="flex gap-5 items-start">
          <div className="text-pink-500 text-3xl font-bold shrink-0">3</div>
          <div>
            <h2 className="text-lg font-semibold mb-2">Lưu ý với từng loại vải</h2>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-1">
              <li><b>Cotton:</b> Dễ phai màu khi giặt nóng hoặc phơi nắng gắt.</li>
              <li><b>Jean/Denim:</b> Không nên giặt chung với đồ sáng màu, hạn chế sử dụng bàn chải cứng.</li>
              <li><b>Linen:</b> Dễ nhăn, nên là ở nhiệt độ vừa phải khi còn hơi ẩm.</li>
              <li><b>Vải tổng hợp:</b> Nên phơi ngang để giữ form, tránh ủi ở nhiệt độ cao.</li>
            </ul>
          </div>
        </section>

        {/* 4. Hỗ trợ & giải đáp */}
        <section className="flex gap-5 items-start">
          <div className="text-pink-500 text-3xl font-bold shrink-0">4</div>
          <div>
            <h2 className="text-lg font-semibold mb-2">Cần hỗ trợ thêm?</h2>
            <p className="text-gray-700">
              Nếu có bất kỳ thắc mắc về việc sử dụng, bảo quản sản phẩm, bạn vui lòng liên hệ hotline&nbsp;
              <a href="tel:0784992000" className="text-pink-600 underline font-medium">0784 992 000</a>
              &nbsp;để được tư vấn tận tình!
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
